import React, { useEffect, useState } from 'react'

const Popover = ({ title, content, isVisible, onClose, placement = 'right' }) => {
  const [animate, setAnimate] = useState(false)

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setAnimate(true)
      }, 100)

      return () => clearTimeout(timer)
    }
  }, [isVisible])

  const getPlacementStyles = () => {
    const baseStyles = {
      position: 'absolute',
      zIndex: 1000,
    }

    switch (placement) {
      case 'right':
        return {
          ...baseStyles,
          left: '100%',
          top: '50%',
          transform: 'translateY(-50%)',
          marginLeft: '15px',
        }
      default:
        return baseStyles
    }
  }

  const getCaretStyles = () => {
    const baseStyles = {
      position: 'absolute',
      width: '12px',
      height: '12px',
      backgroundColor: '#f8f9fa', // Light background to match header
      border: '1px solid rgba(0,0,0,0.1)',
      transform: 'rotate(45deg)',
      boxShadow: '-2px -2px 2px rgba(0,0,0,0.03)',
    }

    switch (placement) {
      case 'right':
        return {
          ...baseStyles,
          left: '-7px',
          top: 'calc(50% - 6px)',
          borderRight: 'none',
          borderTop: 'none',
        }
      default:
        return baseStyles
    }
  }

  if (!isVisible) return null

  return (
    <div
      className='bg-white rounded'
      style={{
        ...getPlacementStyles(),
        width: '280px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        border: '1px solid rgba(0,0,0,0.1)',
        animation: animate ? 'popoverAttention 2.5s ease-in-out' : 'none',
      }}
    >
      <style>
        {`
          @keyframes popoverAttention {
            0%, 100% { transform: translateY(-50%) scale(1); }
            10% { transform: translateY(-50%) scale(1.02); }
            20% { transform: translateY(-50%) scale(1); }
            30% { transform: translateY(-50%) scale(1.02); }
            40% { transform: translateY(-50%) scale(1); }
            50% { transform: translateY(-50%) scale(1.02); }
            60% { transform: translateY(-50%) scale(1); }
            70% { transform: translateY(-50%) scale(1.02); }
            80% { transform: translateY(-50%) scale(1); }
            90% { transform: translateY(-50%) scale(1.02); }
          }

          @keyframes caretAttention {
            0%, 100% { transform: rotate(45deg) scale(1); }
            10% { transform: rotate(45deg) scale(1.1); }
            20% { transform: rotate(45deg) scale(1); }
            30% { transform: rotate(45deg) scale(1.1); }
            40% { transform: rotate(45deg) scale(1); }
            50% { transform: rotate(45deg) scale(1.1); }
            60% { transform: rotate(45deg) scale(1); }
            70% { transform: rotate(45deg) scale(1.1); }
            80% { transform: rotate(45deg) scale(1); }
            90% { transform: rotate(45deg) scale(1.1); }
          }
        `}
      </style>

      {/* Caret */}
      <div
        style={{
          ...getCaretStyles(),
          animation: animate ? 'caretAttention 2.5s ease-in-out' : 'none',
        }}
      />

      {/* Header */}
      <div
        className='bg-light rounded-top p-3 border-bottom'
        style={{
          background: 'linear-gradient(to bottom, #f8f9fa, #fff)',
        }}
      >
        <h6 className='mb-0 text-primary fw-bold'>{title}</h6>
      </div>

      {/* Content */}
      <div className='p-3'>
        <p className='text-dark mb-3' style={{ fontSize: '0.95rem' }}>
          {content}
        </p>
        <div className='d-flex justify-content-end'>
          <button
            className='btn btn-primary btn-sm px-3'
            onClick={onClose}
            style={{
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              fontWeight: '500',
            }}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  )
}

export default Popover
